'use strict';

export const progressTypes = {
  DONE: 'done',
  ACTIVE: 'activeAndInCharge',
  ACTIVE_AND_PENDING: 'activeAndPending',
  ACTIVE_AND_DECLINED: 'activeAndDeclined',
  ACTIVE_AND_COMPLETED: 'activeAndCompleted',
  UPCOMING: 'upcoming'
};

export const typesToIconsMapping = {
  [progressTypes.DONE] : 'fa-check',
  [progressTypes.ACTIVE] : 'fa-file-text-o',
  [progressTypes.ACTIVE_AND_PENDING] : 'fa-clock-o',
  [progressTypes.ACTIVE_AND_DECLINED] : 'fa-file-text-o',
  [progressTypes.ACTIVE_AND_COMPLETED] : 'fa-check',
  [progressTypes.UPCOMING] : 'fa-circle-o'
};
